function CollapseView({ audit }) {
  return (
    <div className="border p-3 rounded bg-white">
      <div className="mb-3">
        <p className="mb-1">
          <strong>User:</strong> {audit?.user?.email}
        </p>
        <p className="mb-1">
          <strong>Log Date:</strong>{" "}
          {audit?.logDate &&
            new Date(audit.logDate).toLocaleString("en-US", {
              month: "long", // March
              day: "numeric", // 2
              year: "numeric", // 2025
              hour: "numeric", // 5
              minute: "2-digit", // 15
              hour12: true, // am/pm
            })}
        </p>

        <p className="mb-1">
          <strong>Activity:</strong> {audit?.activity}
        </p>
        <p className="mb-1">
          <strong>Message:</strong> {audit?.message}
        </p>
      </div>
    </div>
  );
}

export default CollapseView;
